module.exports = __webpack_public_path__ + "img/Ko-T200.33211fed.gif";